import { pick } from "ramda";
import { FC, useState } from "react";
import { TextInput, TextInputProps } from "react-admin";

import InputFieldCounter from "./InputFieldCounter";

const TextInputWithCounter: FC<any> = ({ counter, multiline, rows = 8, ...props }) => {
  // const inputValue = (() => {
  //   const isLocalized = props.source.split(".")[1];
  //   if (!isLocalized) return props.record[props.source];
  //   else {
  //     if (props.record[props.source.split(".")[0]])
  //       return props.record[props.source.split(".")[0]][props.source.split(".")[1]];
  //     else return "";
  //   }
  // })();

  const inputValue = (() => {
    if (props.source.split(".").length === 2) {
      const isLocalized = props.source.split(".")[1];
      if (!isLocalized) return props.record[props.source];
      else {
        if (props.record[props.source.split(".")[0]])
          return props.record[props.source.split(".")[0]][props.source.split(".")[1]];
        else return "";
      }
    } else if (props.source.split(".").length === 3) {
      const isLocalized = props.source.split(".")[1];
      if (!isLocalized) return props.record[props.source];
      else {
        if (props.record[props.source.split(".")[0]])
          return props.record[props.source.split(".")[0]][props.source.split(".")[1]][props.source.split(".")[2]];
        else return "";
      }
    }
  })();

  const [val, setVal] = useState(inputValue);

  const textInputProps = pick(["source", "variant", "label", "resource", "validate"])(props) as TextInputProps;

  return (
    <TextInput
      {...textInputProps}
      multiline={multiline}
      rows={multiline ? rows : 1}
      value={val}
      fullWidth
      onChange={(e) => setVal(e.target.value)}
      InputProps={{
        endAdornment: counter ? (
          <InputFieldCounter counter={counter} length={val.length} alignSelf={multiline ? "flex-end" : "center"} />
        ) : null,
      }}
    />
  );
};

export default TextInputWithCounter;
